import { Controller, useFormContext } from "react-hook-form";
import { intl } from "LocaleWrapper";
import { FormGroup, Select } from "@cofano/cck";
import { Grid2 as Grid } from "@mui/material";
import { TankConfiguration } from "__generated__/enums";
import { ShipSchemaInput, ShipSchemaOutput } from "view/ships/utils/ship.schema";

const ShipTankPropertiesForm = ({ disabled }: { disabled?: boolean }) => {
	const { control, setValue } = useFormContext<ShipSchemaInput, unknown, ShipSchemaOutput>();

	return (
		<Grid size={6}>
			<FormGroup overflow="visible" labelPlacement="left-center" label={intl.formatMessage({ id: "SHIP_TANK_CONFIGURATION" })}>
				<Controller
					control={control}
					name={"tankProperties.tankConfiguration"}
					render={({ field }) => (
						<Select
							value={field.value}
							onChange={(option) => {
								if (option !== field.value) {
									setValue("tanks", []);
								}
								field.onChange(option, false);
							}}
							fetchOptions={Object.values(TankConfiguration)}
							getOptionLabel={(option) => intl.formatMessage({ id: `SHIP_${option}` })}
							clearable={false}
							disabled={disabled}
							disableSearch={true} />
					)}
				/>
			</FormGroup>
		</Grid>
	);
};

export default ShipTankPropertiesForm;
